import { getDataAPI, postDataAPI } from "../../../services/apiWrapper";
import { errorAlert } from "../../../utils/alert";

/*
 * Center-side actions for the center's own registration fee.
 *
 * The center id is never sent - the server reads it from the login token, so a
 * center can only ever see and pay against its own account.
 */

const centerToken = () => localStorage.getItem("centerToken");

/** Fee, amount paid so far, balance and payment history for this center. */
export const getMyCenterFee = () => async (dispatch) => {
  try {
    const response = await dispatch(
      getDataAPI("center/fee/status", centerToken())
    );
    return response ? response.data.data : false;
  } catch (error) {
    return false;
  }
};

/**
 * Record a Razorpay payment made by this center. Only the payment id is sent;
 * the server asks Razorpay what was actually paid.
 */
export const recordCenterFeePayment = (data) => async (dispatch) => {
  try {
    const response = await dispatch(
      postDataAPI("center/fee/success", data, centerToken())
    );
    return response ? response.data : false;
  } catch (error) {
    errorAlert(
      error.response?.data?.message || "Could not record the payment."
    );
    return false;
  }
};
